/* HAKAN HISIM SHOPIFY THEME — theme.js v1.0 */

/* ── CURSOR ────────────────────────────────── */
(function initCursor(){
  if(window.matchMedia('(hover:none)').matches) return;
  const dot = document.createElement('div'); dot.className='cursor-dot';
  const ring = document.createElement('div'); ring.className='cursor-ring';
  document.body.append(dot,ring);
  let mx=0,my=0,rx=0,ry=0;
  document.addEventListener('mousemove',e=>{mx=e.clientX;my=e.clientY;dot.style.left=mx+'px';dot.style.top=my+'px';});
  (function lerp(){rx+=(mx-rx)*0.12;ry+=(my-ry)*0.12;ring.style.left=rx+'px';ring.style.top=ry+'px';requestAnimationFrame(lerp);})();
  document.querySelectorAll('a,button,.cat-card,.product-card,.gallery-thumb').forEach(el=>{
    el.addEventListener('mouseenter',()=>ring.classList.add('expanded'));
    el.addEventListener('mouseleave',()=>ring.classList.remove('expanded'));
  });
})();

/* ── SCROLL REVEAL ─────────────────────────── */
(function initReveal(){
  const io = new IntersectionObserver(entries=>{
    entries.forEach(e=>{ if(e.isIntersecting) e.target.classList.add('visible'); });
  },{threshold:0.08,rootMargin:'0px 0px -40px 0px'});
  document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
})();

/* ── HEADER SCROLL ─────────────────────────── */
(function initHeader(){
  const h = document.querySelector('.site-header');
  if(!h) return;
  const onScroll=()=>h.classList.toggle('scrolled',window.scrollY>80);
  window.addEventListener('scroll',onScroll,{passive:true});
  onScroll();
})();

/* ── MOBILE NAV ────────────────────────────── */
(function initMobileNav(){
  const btn = document.querySelector('.menu-btn');
  const nav = document.querySelector('.mobile-nav');
  if(!btn||!nav) return;
  btn.addEventListener('click',()=>{
    const open = btn.classList.toggle('open');
    nav.classList.toggle('open',open);
    document.body.style.overflow = open?'hidden':'';
  });
  nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{
    btn.classList.remove('open'); nav.classList.remove('open'); document.body.style.overflow='';
  }));
})();

/* ── SEARCH OVERLAY ────────────────────────── */
(function initSearch(){
  const overlay = document.querySelector('.search-overlay');
  const openBtns = document.querySelectorAll('.header-search-btn');
  const closeBtn = document.querySelector('.search-close');
  const input = document.querySelector('.search-input');
  if(!overlay) return;
  const open=()=>{ overlay.classList.add('open'); document.body.style.overflow='hidden'; setTimeout(()=>input&&input.focus(),100); };
  const close=()=>{ overlay.classList.remove('open'); document.body.style.overflow=''; };
  openBtns.forEach(b=>b.addEventListener('click',open));
  closeBtn&&closeBtn.addEventListener('click',close);
  document.addEventListener('keydown',e=>{ if(e.key==='Escape') close(); });
  overlay.addEventListener('click',e=>{ if(e.target===overlay) close(); });
})();

/* ── CART SYSTEM ───────────────────────────── */
const Cart = {
  async get(){ const r=await fetch('/cart.js'); return r.json(); },
  async add(id,qty=1,props={}){
    const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id,quantity:qty,properties:props})});
    return r.json();
  },
  async update(updates){
    const r=await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});
    return r.json();
  },
  async change(id,qty){
    const r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id,quantity:qty})});
    return r.json();
  },
  formatMoney(cents){
    return '$'+((cents||0)/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');
  }
};

function trackStoreEvent(name,params={}){
  try{
    if(typeof window.gtag==='function') window.gtag('event',name,params);
    else {
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push({event:name,...params});
    }
  }catch(e){ console.warn('Analytics event failed',name,e); }
}
function cartItemEvent(item){
  const cents=Number(item&&item.price)||0;
  const quantity=Number(item&&item.quantity)||1;
  return {currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD',value:(cents*quantity)/100,items:[{item_id:String((item&&item.product_id)|| (item&&item.id)||''),item_name:(item&&item.product_title)||(item&&item.title)||'',item_variant:(item&&item.variant_title)||'',price:cents/100,quantity}]};
}

/* ── CART DRAWER ───────────────────────────── */
const CartDrawer = {
  el: null, overlay: null, itemsEl: null, subtotalEl: null,
  init(){
    this.el = document.getElementById('cart-drawer');
    if(!this.el) return;
    this.overlay = this.el.querySelector('.cart-drawer__overlay');
    this.itemsEl = document.getElementById('cart-drawer-items');
    this.subtotalEl = document.getElementById('cart-subtotal');
    this.el.querySelector('.cart-drawer__close').addEventListener('click',()=>this.close());
    this.overlay.addEventListener('click',()=>this.close());
    document.addEventListener('keydown',e=>{ if(e.key==='Escape') this.close(); });
    document.querySelectorAll('.cart-btn').forEach(b=>b.addEventListener('click',()=>this.open()));
    this.refresh();
  },
  open(){ this.el.classList.add('open'); document.body.style.overflow='hidden'; this.refresh(); },
  close(){ this.el.classList.remove('open'); document.body.style.overflow=''; },
  async refresh(){
    const cart = await Cart.get();
    this.updateCount(cart.item_count);
    this.renderItems(cart);
    if(this.subtotalEl) this.subtotalEl.textContent=Cart.formatMoney(cart.total_price);
  },
  updateCount(n){
    document.querySelectorAll('.cart-count').forEach(el=>{
      el.textContent=n;
      el.classList.add('pulse');
      setTimeout(()=>el.classList.remove('pulse'),400);
    });
  },
  renderItems(cart){
    if(!this.itemsEl) return;
    if(!cart.items||cart.items.length===0){
      this.itemsEl.innerHTML='<div class="cart-drawer__empty">[ No transmissions selected ]</div>';
      return;
    }
    this.itemsEl.innerHTML = cart.items.map(item=>`
      <div class="cart-item" data-key="${item.key}">
        <a href="${item.url}">
          <img class="cart-item__img" src="${item.image}" alt="${item.title}" width="80" height="80">
        </a>
        <div class="cart-item__body">
          <div class="cart-item__title">${item.product_title}</div>
          ${item.variant_title&&item.variant_title!=='Default Title'?`<div class="cart-item__variant">${item.variant_title}</div>`:''}
          <div class="cart-item__price">${Cart.formatMoney(item.final_line_price)}</div>
          <div class="cart-item__row">
            <div class="cart-item__qty">
              <button class="qty-btn" data-action="decrease" data-key="${item.key}" data-qty="${item.quantity}">−</button>
              <span class="qty-val">${item.quantity}</span>
              <button class="qty-btn" data-action="increase" data-key="${item.key}" data-qty="${item.quantity}">+</button>
            </div>
            <button class="cart-item__remove" data-key="${item.key}">Remove</button>
          </div>
        </div>
      </div>
    `).join('');
    this.itemsEl.querySelectorAll('.qty-btn').forEach(btn=>{
      btn.addEventListener('click',async()=>{
        const key=btn.dataset.key; const current=parseInt(btn.dataset.qty);
        const newQty=btn.dataset.action==='increase'?current+1:Math.max(0,current-1);
        await Cart.change(key,newQty); this.refresh();
      });
    });
    this.itemsEl.querySelectorAll('.cart-item__remove').forEach(btn=>{
      btn.addEventListener('click',async()=>{ await Cart.change(btn.dataset.key,0); this.refresh(); });
    });
  }
};

/* ── ADD TO CART ───────────────────────────── */
(function initATC(){
  document.addEventListener('click',async e=>{
    const btn = e.target.closest('[data-action="add-to-cart"]');
    if(!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if(!variantId){ console.warn('No variant ID'); return; }
    const originalText = btn.querySelector('span')?btn.querySelector('span').textContent:btn.textContent;
    btn.disabled=true;
    if(btn.querySelector('span')) btn.querySelector('span').textContent='Adding...';
    else btn.textContent='Adding...';
    try{
      const added = await Cart.add(variantId,1);
      trackStoreEvent('add_to_cart',cartItemEvent(added));
      if(btn.querySelector('span')) btn.querySelector('span').textContent='Added ✓';
      else btn.textContent='Added ✓';
      CartDrawer.open();
      setTimeout(()=>{
        btn.disabled=false;
        if(btn.querySelector('span')) btn.querySelector('span').textContent=originalText;
        else btn.textContent=originalText;
      },2000);
    }catch(err){
      console.error(err);
      btn.disabled=false;
      if(btn.querySelector('span')) btn.querySelector('span').textContent='Error';
      else btn.textContent='Error';
    }
  });
  /* Quick add from product cards */
  document.addEventListener('click',async e=>{
    const btn = e.target.closest('.product-card__quick-add');
    if(!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if(!variantId) return;
    btn.textContent='Adding...';
    try{ const added=await Cart.add(variantId); trackStoreEvent('add_to_cart',cartItemEvent(added)); CartDrawer.open(); btn.textContent='Added ✓'; setTimeout(()=>btn.textContent='Quick Add',1500); }
    catch(e){ btn.textContent='Error'; }
  });
})();

/* ── BUY NOW (variant-bound) ────────────────── */
(function initBuyNow(){
  function selectedVariantId(){
    const atc=document.querySelector('#atc-btn,[data-action="add-to-cart"][data-variant-id]');
    const mobile=document.querySelector('.mobile-product-purchase__cta[data-variant-id]');
    return (atc&&atc.dataset.variantId)||(mobile&&mobile.dataset.variantId)||null;
  }
  document.addEventListener('click',async e=>{
    const btn=e.target.closest('[data-action="buy-now"]');
    if(!btn||btn.disabled) return;
    e.preventDefault();
    const vid=selectedVariantId();
    if(!vid){ console.warn('Buy Now: no variant selected'); return; }
    btn.disabled=true;
    const label=btn.querySelector('span'); const orig=label?label.textContent:btn.textContent;
    if(label) label.textContent='Adding...';
    try{
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:Number(vid),quantity:(function(){const q=document.querySelector('.qty-display');const n=q?parseInt(q.textContent):1;return isNaN(n)?1:n;})()})});
      const added=await r.json();
      if(!r.ok||added.status){ throw new Error(added.description||'add failed'); }
      trackStoreEvent('add_to_cart',cartItemEvent(added));
      if(typeof window.__omniBeginCheckout==='function'){
        window.__omniBeginCheckout(btn,()=>window.location.assign('/checkout'));
      } else {
        window.location.assign('/checkout');
      }
    }catch(err){
      console.error(err);
      btn.disabled=false;
      if(label) label.textContent=orig;
    }
  });
})();

/* ── PRODUCT PAGE ──────────────────────────── */
(function initProductPage(){
  /* Gallery */
  const mainImg = document.getElementById('gallery-main-img');
  const thumbs = document.querySelectorAll('.gallery-thumb');
  thumbs.forEach(thumb=>{
    thumb.addEventListener('click',()=>{
      thumbs.forEach(t=>t.classList.remove('active'));
      thumb.classList.add('active');
      if(mainImg) mainImg.src=thumb.dataset.full||thumb.querySelector('img').src;
    });
  });

  /* Options */
  const optionBtns = document.querySelectorAll('.option-btn');
  optionBtns.forEach(btn=>{
    btn.addEventListener('click',()=>{
      const group=btn.dataset.group;
      document.querySelectorAll(`.option-btn[data-group="${group}"]`).forEach(b=>b.classList.remove('selected'));
      btn.classList.add('selected');
      updateVariant();
    });
  });

  /* Quantity */
  const qtyDisplay=document.querySelector('.qty-display');
  document.querySelectorAll('.qty-box .qty-btn').forEach(btn=>{
    btn.addEventListener('click',()=>{
      if(!qtyDisplay) return;
      let v=parseInt(qtyDisplay.textContent)||1;
      v=btn.dataset.dir==='up'?v+1:Math.max(1,v-1);
      qtyDisplay.textContent=v;
    });
  });

  /* Variant selection */
  function updateVariant(){
    const selected={};
    document.querySelectorAll('.option-btn.selected').forEach(btn=>selected[btn.dataset.group]=btn.dataset.value);
    const atcBtns=document.querySelectorAll('[data-action="add-to-cart"]');
    const variantData=window.__variantData||[];
    const match=variantData.find(v=>{
      return Object.keys(selected).every((g,i)=>v.options[i]===selected[g]);
    });
    if(match){
      atcBtns.forEach(btn=>{
        btn.dataset.variantId=match.id;
        btn.disabled=!match.available;
        const label=btn.querySelector('span');
        if(label && !btn.classList.contains('is-adding')) label.textContent=match.available?'Add to Cart':'Sold Out';
      });
      const priceEl=document.getElementById('product-price');
      if(priceEl) priceEl.textContent=Cart.formatMoney(match.price);
      const mobilePriceEl=document.getElementById('mobile-product-price');
      if(mobilePriceEl) mobilePriceEl.textContent=Cart.formatMoney(match.price);
    }
  }

  /* Accordion */
  document.querySelectorAll('.accordion-trigger').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const panel=btn.nextElementSibling;
      const isOpen=btn.classList.contains('active');
      document.querySelectorAll('.accordion-trigger.active').forEach(b=>{
        b.classList.remove('active');
        b.nextElementSibling.style.maxHeight='0';
      });
      if(!isOpen){
        btn.classList.add('active');
        panel.style.maxHeight=panel.scrollHeight+'px';
      }
    });
  });
})();

/* ── NEWSLETTER ────────────────────────────── */
(function initNewsletter(){
  document.querySelectorAll('.newsletter-form').forEach(form=>{
    form.addEventListener('submit',async e=>{
      if(form.classList.contains('newsletter-form--native')) return;
      e.preventDefault();
      const input=form.querySelector('.newsletter-input');
      const btn=form.querySelector('.newsletter-btn');
      if(!input||!input.value.includes('@')) return;
      btn.textContent='Transmitting...';
      btn.disabled=true;
      // Shopify handles form submission natively; this is fallback UX
      setTimeout(()=>{
        const success=form.nextElementSibling;
        if(success&&success.classList.contains('newsletter-success')){ success.style.display='block'; form.style.display='none'; }
        else{ input.value='◈ Signal received ◈'; input.style.color='rgba(0,255,179,0.8)'; btn.textContent='Sent ✓'; }
      },800);
    });
  });
})();

/* ── GLITCH TEXT PERIODIC TRIGGER ──────────── */
(function initGlitch(){
  const els=document.querySelectorAll('.glitch-text');
  setInterval(()=>{ els.forEach(el=>{ if(Math.random()>0.7){ el.style.animation='none'; void el.offsetHeight; el.style.animation=''; } }); },4500);
})();

/* ── MARQUEE PAUSE ON HOVER ─────────────────── */
(function initMarquee(){
  document.querySelectorAll('.marquee-track').forEach(track=>{
    track.parentElement.addEventListener('mouseenter',()=>track.style.animationPlayState='paused');
    track.parentElement.addEventListener('mouseleave',()=>track.style.animationPlayState='running');
  });
})();

/* ── INIT ───────────────────────────────────── */
document.addEventListener('DOMContentLoaded',()=>{
  CartDrawer.init();

/* ── HOVER PRODUCT VIDEOS ───────────────────── */
(function initHoverProductVideos(){
  if(window.matchMedia('(hover:none)').matches) return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('.best-sellers-card.has-hover-video').forEach(card=>{
    const video = card.querySelector('video');
    if(!video) return;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'metadata';
    const playVideo = () => {
      card.classList.add('is-playing');
      const promise = video.play();
      if(promise && promise.catch) promise.catch(() => {});
    };
    const stopVideo = () => {
      card.classList.remove('is-playing');
      video.pause();
      try { video.currentTime = 0; } catch (e) {}
    };
    card.addEventListener('mouseenter', playVideo);
    card.addEventListener('mouseleave', stopVideo);
    card.addEventListener('focusin', playVideo);
    card.addEventListener('focusout', event => {
      if(!card.contains(event.relatedTarget)) stopVideo();
    });
  });
})();
  CartDrawer.refresh();
});

/* ── PDP POPUP CONVERSION GUARD ──────────────── */
(function suppressPdpMarketingPopup(){
  if(!document.body || !document.body.matches('body.template-product,body.template-cart')) return;
  const selector='[role="dialog"][aria-label="Marketing offer form"],[class*="omnisend-form"][class*="-container"]';
  const hide=(root)=>{
    if(root.nodeType!==1 && root!==document) return;
    if(root.matches && root.matches(selector)) root.style.setProperty('display','none','important');
    if(root.querySelectorAll) root.querySelectorAll(selector).forEach(el=>el.style.setProperty('display','none','important'));
  };
  hide(document);
  new MutationObserver(mutations=>mutations.forEach(m=>m.addedNodes.forEach(hide))).observe(document.documentElement,{childList:true,subtree:true});
})();

/* ── LAZY PRODUCT-CARD HOVER VIDEO ─────────── */
(function initProductCardHoverVideo(){
  if (!window.matchMedia) return;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!finePointer.matches || reducedMotion.matches) return;
  document.querySelectorAll('.product-card.has-hover-video').forEach(card=>{
    const template = card.querySelector('template[data-product-card-video]');
    const wrap = card.querySelector('.product-card__video-wrap');
    if (!template || !wrap) return;
    let video = null;
    let hydrated = false;
    let engaged = false;
    const hydrate = ()=>{
      if (!finePointer.matches || reducedMotion.matches) return;
      engaged = true;
      if (!hydrated) {
        wrap.appendChild(template.content.cloneNode(true));
        video = wrap.querySelector('video');
        hydrated = true;
        if (video) {
          video.addEventListener('playing', ()=>{
            if (engaged && finePointer.matches && !reducedMotion.matches) card.classList.add('is-playing');
            else video.pause();
          });
          video.addEventListener('error', ()=>card.classList.remove('is-playing'));
        }
      }
      if (!video) return;
      const playback = video.play();
      if (playback && playback.catch) playback.catch(()=>card.classList.remove('is-playing'));
    };
    const stop = ()=>{
      engaged = false;
      card.classList.remove('is-playing');
      if (!video) return;
      video.pause();
      try { video.currentTime = 0; } catch (e) {}
    };
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', stop);
    if (finePointer.addEventListener) finePointer.addEventListener('change', stop);
    card.addEventListener('mouseenter', hydrate);
    card.addEventListener('focusin', hydrate);
    card.addEventListener('mouseleave', stop);
    card.addEventListener('focusout', event=>{
      if (!card.contains(event.relatedTarget)) stop();
    });
  });
})();

/* ── PRODUCT GALLERY ───────────────────────── */
(function initGallery(){
  const main=document.getElementById('gallery-main-img');
  const thumbs=[...document.querySelectorAll('.gallery-thumb')];
  if(!main || !thumbs.length) return;

  function select(btn){
    const full=btn.dataset.full;
    if(!full) return;
    // swap the large image and keep it responsive
    if(main.srcset){
      main.srcset=full.replace(/width=\d+/,'width=600')+' 600w, '+full.replace(/width=\d+/,'width=900')+' 900w, '+
                 full.replace(/width=\d+/,'width=1200')+' 1200w, '+full.replace(/width=\d+/,'width=1600')+' 1600w';
    }
    main.src=full;
    main.style.opacity='0.35';
    requestAnimationFrame(()=>{ main.style.opacity='1'; });
    thumbs.forEach(t=>t.classList.toggle('active',t===btn));
  }

  thumbs.forEach(btn=>{
    btn.addEventListener('click',()=>select(btn));
    // keyboard support
    if(!btn.hasAttribute('tabindex')) btn.setAttribute('tabindex','0');
    btn.addEventListener('keydown',e=>{
      if(e.key==='Enter'||e.key===' '){ e.preventDefault(); select(btn); }
    });
  });

  // arrow-key navigation
  const row=document.querySelector('.gallery-thumbs');
  if(row){
    row.addEventListener('keydown',e=>{
      const i=thumbs.indexOf(document.activeElement);
      if(i<0) return;
      if(e.key==='ArrowRight'||e.key==='ArrowDown'){
        e.preventDefault(); const n=thumbs[(i+1)%thumbs.length]; n.focus(); select(n);
      } else if(e.key==='ArrowLeft'||e.key==='ArrowUp'){
        e.preventDefault(); const n=thumbs[(i-1+thumbs.length)%thumbs.length]; n.focus(); select(n);
      }
    });
  }
})();
